export class ArrayUtils {
  public static isEqual(a: any[], b: any[]): boolean {
    return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val, index) => val === b[index]);
  }

  public static remove(arr: any[], item: any): any[] {
    const index = arr.indexOf(item);
    if (index > -1) {
      arr.splice(index, 1);
    }

    return arr;
  }
}
